import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  margin-top: 150px;
`;
const Text = styled.p`
  font-family: "Khmer OS Content Regular", arial, sans-serif;
  font-size: 14px;
  margin: 0;
  padding: 0;
`;
const Line = styled.div`
  background: black;
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
`;

class Signature extends React.Component {
  render() {
    const { type } = this.props;
    return (
      <Container>
        <Line />
        <Text>ហត្ថលេខា និងឈ្មោះអ្នក{type === "buyer" ? "ទិញ" : "លក់"} </Text>
        <Text>
          {type === "buyer" ? "Customer" : "Seller"}'s Signature & Name
        </Text>
      </Container>
    );
  }
}

export { Signature };
export default Signature;
